import Vue from 'vue';
import Component from 'vue-class-component';
import {AuthorisationManager, Identity, Icon} from 'wc-lib';
import {EnvironmentBar} from './environment-bar';
import {PersistentNotification} from '../components/persistent-notification';
import {Footer} from './footer';
import {Service} from '../service';
import Config from '../config';

require('../../icons/error.svg');

@Component({
  template: require('./sign-in.html'),
  components: {
    'environment-bar': EnvironmentBar,
    'aemo-footer': Footer,
    'persistent-notification': PersistentNotification,
    'wc-icon': Icon
  }
})
export class SignIn extends Vue {
  identity: Identity;
  userId: string = '';
  password: string = '';
  error: string = null;
  environment: string = '';
  backgroundImage: string = '';
  iwa: boolean = false;
  title: string = '';
  skipLogin: boolean = false;
  hide: boolean = true;
  passwordError: string = null;
  identityRedirectUrl: string = '';

  created() {
    this.environment = Config.environment;
    this.title = Config.title;
    this.iwa = Config.identityIwaEnabled;
    this.backgroundImage = Config.backgroundImage;
    this.identityRedirectUrl = Config.identityRedirectUrl;
    AuthorisationManager.removeParticipant();
    localStorage.removeItem('aemo-session');

    if (this.$route.query.externalAuth) {
      this.externalProviderAuth();
    } else {
      this.skipLogin = Config.skipLogin;
      if(this.skipLogin) {
        this.signin();
      } else {
        Service.signOut();
      }
  
      if (this.identityRedirectUrl) {
       window.location.href = this.identityRedirectUrl;
      }
    }
  }

  async signin() {
    this.error = null;
    this.passwordError = null;
    if (this.validatePassword()) {
      this.hide = false;
      if (Config.identityIwaEnabled && this.userId === '' && this.password === '') {
        this.identity = await Service.authenticateIwa();
      } else {
        this.identity = await Service.authenticate(this.userId, this.password);
      }
      this.configureSession();

      this.userId = '';
      this.password = '';
    }
  }

  async externalProviderAuth() {
    this.identity = await AuthorisationManager.SessionData();
    this.configureSession();
  }

  configureSession() {
    if (this.identity.UserId && !this.identity.PasswordReset) {
      // Remove session ID for local storage 
      this.identity.SessionId = '';
      localStorage.setItem('aemo-session', JSON.stringify(this.identity));
      AuthorisationManager.setParticipant(this.identity.PrimaryParticipantId, this.identity.PrimaryParticipantName);
      this.$router.push('menu');
    } else if (this.identity.UserId && this.identity.PasswordReset) {
      localStorage.setItem('aemo-session', JSON.stringify(this.identity));
      this.$router.push({ path: 'change-password' });
    } else {
      this.error = 'Invalid Username or Password';
      this.hide = true;
    }
  }

  reset() {
    this.error = '';
    this.passwordError = '';
    this.userId = '';
    this.password = '';
  }

  validatePassword(): boolean {
    this.passwordError = null;
    if (this.userId && !this.password) {
      this.passwordError = 'The password field is required';
      return false;
    }

    return true;
  }

  mounted() {
    if (top.location.hostname == location.hostname && top.location != location) {
      top.location.href = document.location.href;
    }
    if (this.skipLogin == false && !this.identityRedirectUrl) {
      (this.$refs.signInInput as HTMLInputElement).focus();
    }
  }
}



// WEBPACK FOOTER //
// src/views/sign-in.ts